import PromotionsRoot from './Promotions';

const PromotionsList = () => import(/* webpackChunkName: "promotions" */ './PromotionsList');
const PromotionsCreateUpdate = () => import(/* webpackChunkName: "promotions" */ './PromotionsCreateUpdate');

export default {
  path: '/coupons',
  name: 'promotions',
  redirect: '/coupons/all',
  component: PromotionsRoot,
  children: [{
    path: 'all',
    name: 'promotionsAll',
    component: PromotionsList,
  }, {
    path: ':promotionId/edit',
    name: 'promotionsEdit',
    component: PromotionsCreateUpdate,
    props: true
  }, {
    path: 'create',
    name: 'promotionsCreate',
    component: PromotionsCreateUpdate,
  }],
};